import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useProductsContext } from '../../context/products_context';
import { useFilterContext } from '../../context/filter_context';
import { FaTimes, FaHome, FaInfoCircle, FaShoppingBag, FaCreditCard, FaClipboardList, FaChevronRight, FaUser, FaUtensils, FaCouch, FaBed, FaBath, FaArchive } from 'react-icons/fa';
import SidebarContainer from './styles';
import { useUserContext } from '../../context/user_context';
import { useLanguageContext } from '../../context/language_context';
import daristaGoldLogo from '../../assets/daristaGoldLogoPM.png';

const Sidebar = () => {
  const { currentUser } = useUserContext();
  const { isSidebarOpen, closeSidebar } = useProductsContext();
  const { setCategoryFilter } = useFilterContext();
  const { t, isArabic } = useLanguageContext();
  const history = useHistory();

  // Define all categories with their icons
  const allCategories = [
    { name: 'Kitchen', icon: FaUtensils },
    { name: 'Living Room', icon: FaCouch },
    { name: 'Bedroom', icon: FaBed },
    { name: 'Bathroom', icon: FaBath },
    { name: 'Storage', icon: FaArchive }
  ];

  const handleCategoryClick = (category) => {
    setCategoryFilter(category);
    closeSidebar();
    history.push('/products');
  };

  return (
    <SidebarContainer className={isArabic ? 'rtl' : ''}>
      <aside
        className={`${isSidebarOpen ? 'sidebar show-sidebar' : 'sidebar'}`}
      >
        {/* Menu Header */}
        <div className='sidebar-header'>
          <Link to='/' className='sidebar-brand' onClick={closeSidebar}>
            <img src={daristaGoldLogo} alt='Darista' style={{ height: '90px', width: 'auto' }} />
          </Link>
          <button type='button' className='close-btn' onClick={closeSidebar}>
            <FaTimes />
          </button>
        </div>

        <div className='sidebar-content'>
          {/* Main Navigation */}
          <div className='nav-section'>
            <h4 className='section-title'>{t.nav.menu || 'Menu'}</h4>
            <ul className='links'>
              <li>
                <Link to='/' onClick={closeSidebar} className='menu-link'>
                  <div className='link-icon-wrapper'>
                    <FaHome className='link-icon' />
                  </div>
                  <span className='link-text'>{t.nav.home}</span>
                  <FaChevronRight className='chevron' />
                </Link>
              </li>
              <li>
                <Link to='/about' onClick={closeSidebar} className='menu-link'>
                  <div className='link-icon-wrapper'>
                    <FaInfoCircle className='link-icon' />
                  </div>
                  <span className='link-text'>{t.nav.about}</span>
                  <FaChevronRight className='chevron' />
                </Link>
              </li>
              <li>
                <Link to='/products' onClick={closeSidebar} className='menu-link'>
                  <div className='link-icon-wrapper'>
                    <FaShoppingBag className='link-icon' />
                  </div>
                  <span className='link-text'>{t.nav.products}</span>
                  <FaChevronRight className='chevron' />
                </Link>
              </li>
              {currentUser && (
                <li>
                  <Link to='/checkout' onClick={closeSidebar} className='menu-link'>
                    <div className='link-icon-wrapper'>
                      <FaCreditCard className='link-icon' />
                    </div>
                    <span className='link-text'>{t.nav.checkout}</span>
                    <FaChevronRight className='chevron' />
                  </Link>
                </li>
              )}
              {currentUser && (
                <li>
                  <Link to='/orders' onClick={closeSidebar} className='menu-link'>
                    <div className='link-icon-wrapper'>
                      <FaClipboardList className='link-icon' />
                    </div>
                    <span className='link-text'>{t.nav.orders}</span>
                    <FaChevronRight className='chevron' />
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Categories Section */}
          <div className='nav-section categories-section'>
            <h4 className='section-title'>{t.filters?.category || 'Categories'}</h4>
            <div className='categories-pills'>
              {allCategories.map((category, index) => {
                const IconComponent = category.icon;
                return (
                  <button
                    key={index}
                    type='button'
                    className='category-pill'
                    onClick={() => handleCategoryClick(category.name)}
                  >
                    <IconComponent className='category-icon' />
                    <span className='category-name'>{category.name}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Bottom Actions */}
          <div className='bottom-actions'>
            <Link to={currentUser ? '/profile' : '/login'} className='action-btn account-btn' onClick={closeSidebar}>
              <FaUser className='action-icon' />
              <span className='action-text'>{isArabic ? 'الحساب' : 'Account'}</span>
            </Link>
          </div>
        </div>
      </aside>
    </SidebarContainer>
  );
};

export default Sidebar;
